import moment from 'moment/moment';
import RcPagination from 'rc-pagination';
import { memo } from 'react';
import { Card, CardBody, Table } from 'reactstrap';

import history from '../../utils/createHistory';
import useQuery from '../../utils/useQuery';
import { TableHasNoData, TableLoading } from '../TableHasNoData';
import TableHead from '../TableHead';

import SortButton from './SortButtin';

const PromoPerformanceList = ({ list, loading, onSearch }) => {
  const query = useQuery();
  const { location } = history;
  const pageChangeHandler = page => {
    const values = {
      ...query.value,
      endTime: query?.value?.endTime
        ? moment(query?.value?.endTime).toDate()
        : '',
      page,
      page_size: 10,
      salesChannel: JSON.parse(
        query?.value?.salesChannel ||
          JSON.stringify([{ label: 'online', value: '' }]),
      ),
      startTime: query?.value?.startTime
        ? moment(query?.value?.startTime).toDate()
        : '',
    };
    const params = new URLSearchParams({
      ...values,
      salesChannel: JSON.stringify(
        values?.salesChannel || [{ label: 'online', value: '' }],
      ),
    });

    onSearch({
      couponType: values?.couponType || undefined,
      endTime: values?.endTime || undefined,
      getWay: values?.getWay || undefined,
      keywords: values?.keyword ?? undefined,
      order: values?.order || 'asc',
      order_by: values?.order_by || '',
      page: values?.page,
      page_size: 10,
      queryDateType: values?.queryDateType ?? undefined,
      salesChannel: values?.salesChannel.map(s => s.value).filter(s => s),
      startTime: values?.startTime || undefined,
    });
    history.push(`${location.pathname}?${params.toString()}`);
  };

  return (
    <Card>
      <CardBody>
        <div className="table-responsive mb-3">
          <Table hover striped bordered className="mb-5">
            <TableHead>
              <tr>
                <th>
                  <SortButton currentOrder="promoNo" onSearch={onSearch}>
                    活動序號
                  </SortButton>

                  <SortButton currentOrder="promoName" onSearch={onSearch}>
                    活動名稱
                  </SortButton>
                </th>
                <th>
                  <SortButton
                    currentOrder="redeemStartTime"
                    onSearch={onSearch}
                  >
                    使用期間
                  </SortButton>
                </th>
                <th>
                  <SortButton currentOrder="discountType" onSearch={onSearch}>
                    折抵類型
                  </SortButton>
                </th>
                <th>
                  <SortButton currentOrder="discountAmount" onSearch={onSearch}>
                    面額
                  </SortButton>
                </th>
                <th>
                  <SortButton
                    currentOrder="totalUsedOnlineQty"
                    onSearch={onSearch}
                  >
                    使用張數
                  </SortButton>
                  <div>(官網)</div>
                </th>
                <th>
                  <SortButton
                    currentOrder="totalUsedOfflineQty"
                    onSearch={onSearch}
                  >
                    使用張數
                  </SortButton>
                  <div>(門市)</div>
                </th>
                <th>
                  <SortButton currentOrder="totalUsedQty" onSearch={onSearch}>
                    總使用張數
                  </SortButton>
                </th>

                <th>
                  <SortButton
                    currentOrder="totalDiscountAmount"
                    onSearch={onSearch}
                  >
                    折價券折抵總金額
                  </SortButton>
                  <div>(官網)</div>
                </th>
                <th>
                  <SortButton
                    currentOrder="totalOrderAmount"
                    onSearch={onSearch}
                  >
                    訂單實付總金額
                  </SortButton>
                  <div>(官網)</div>
                </th>
              </tr>
            </TableHead>
            {loading && <TableLoading />}
            {!loading && (
              <tbody>
                {list.datas?.length ? (
                  list.datas.map(d => {
                    return (
                      <tr key={JSON.stringify(d)}>
                        <td>
                          <div>{d.promoNo || '--'}</div>
                          <div>{d.promoName || '--'}</div>
                          {/*TODO 活動名稱待補*/}
                        </td>
                        <td>
                          <div className="text-nowrap">
                            {d.redeemStartTime
                              ? moment(d.redeemStartTime).format(
                                  'YYYY/MM/DD HH:mm:ss',
                                )
                              : '--'}
                            起
                          </div>
                          <div className="text-nowrap">
                            {d.redeemEndTime
                              ? moment(d.redeemEndTime).format(
                                  'YYYY/MM/DD HH:mm:ss',
                                )
                              : '--'}
                            迄
                          </div>
                        </td>
                        <td>
                          <div className="text-center">
                            {d.discountTypeLabel || '--'}
                          </div>
                        </td>
                        <td>
                          <div className="text-center">
                            {d.discountType === 1 && 'NT$'}{' '}
                            {(d.discountAmount ?? '0').toLocaleString()}
                            {d.discountType !== 1 && '折'}{' '}
                          </div>
                        </td>
                        <td>
                          <div className="text-center">
                            {(d.totalUsedOnlineQty ?? '0').toLocaleString()}
                          </div>
                        </td>
                        <td>
                          <div className="text-center">
                            {(d.totalUsedOfflineQty ?? '0').toLocaleString()}
                          </div>
                        </td>
                        <td>
                          <div className="text-center">
                            {(d.totalUsedQty ?? '0').toLocaleString()}
                          </div>
                        </td>
                        <td>
                          <div className="text-center text-nowrap">
                            - NT${' '}
                            {(d.totalDiscountAmount ?? '0').toLocaleString()}
                          </div>
                        </td>
                        <td>
                          <div className="text-center text-nowrap">
                            NT$ {(d.totalOrderAmount ?? '0').toLocaleString()}
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <TableHasNoData />
                )}
              </tbody>
            )}
          </Table>
        </div>
        <div className="d-flex align-items-center justify-content-center">
          <RcPagination
            current={list?.current_page || 1}
            pageSize={list?.page_size || 50}
            style={{ borderColor: '#446' }}
            total={list?.total_count || 0}
            onChange={pageChangeHandler}
          />
        </div>
      </CardBody>
    </Card>
  );
};

export default memo(PromoPerformanceList);
